export default function Svg({ url, height, width }) {
  return (
    <svg width={width} height={height}>
      <image xlinkHref={url} width={width} height={height} />
    </svg>
  )
}
